import { useSelector } from 'react-redux';
import FJLoadingModal from './FJLoadingModal';
import FJModal from '../FJModal';

const FJLoadingModalContainer = () => {
    const isShow = useSelector(state => state.modals.loadingModalData.display);
    const message = useSelector(state => state.modals.loadingModalData.message);

    return (
        <FJModal visible={isShow} zIndex={1002}>
            <FJLoadingModal message={message} />
        </FJModal>
    );
};

export default FJLoadingModalContainer;
